var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{staticClass:"main-box top-zero-radius md:w-1/2 mx-auto"},[_c('vs-button',{staticClass:"w-full",attrs:{"color":"danger"},on:{"click":_vm.truncateAccountingDatabase}},[_vm._v(" پاکسازی دیتابیس حسابداری ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }